import React from "react";
const Dot = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="3"
        height="4"
        viewBox="0 0 3 4"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx="1.5" cy="2" r="1.5" fill="#9876D5" />
    </svg>
);

export default Dot;
